"use client"

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Separator } from "@/components/ui/separator"
import { buttonVariants } from "@/components/ui/button"
import Link from "next/link"
import { cn } from "@/lib/utils"
import { useEffect, useState } from "react"

export const DemoDialog = () => {
  const [open, setOpen] = useDemoDialogListener()
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="text-xl">Unlock Full Access</DialogTitle>
          <DialogDescription className="text-base">
            Sign up for access to Genie's features
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-6 py-4">
          <div className="space-y-2">
            <h3 className="font-medium">With a Cosine account, you can:</h3>
            <ul className="ml-6 list-disc text-sm">
              <li>Give software tasks to Genie</li>
              <li>Rapidly ship features and fix bugs</li>
              <li>Assign issues from your ticket manager</li>
              <li>Automatically respond to CI runs</li>
            </ul>
          </div>
          <Separator />
          <Link href={"/login"} className={cn(buttonVariants({ variant: "default" }), "w-full")}>
            Sign Up
          </Link>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export const OPEN_DEMO_DIALOG_EVENT = "open-demo-dialog"

export const useDemoDialogListener = () => {
  const [open, setOpen] = useState(false)
  useEffect(() => {
    const handler = () => setOpen(true)
    window.addEventListener(OPEN_DEMO_DIALOG_EVENT, handler)
    return () => window.removeEventListener(OPEN_DEMO_DIALOG_EVENT, handler)
  }, [])
  return [open, setOpen] as const
}

export const openDemoDialog = () => window?.dispatchEvent(new Event(OPEN_DEMO_DIALOG_EVENT))
